import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_loaddata_quottions_invocie = (quotations_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.PAYMENT_INVOICE}/get-quottions-invocie/${quotations_id}`);
};
export const billing_expense_create_payment_invoice = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.PAYMENT_INVOICE}/`, data);
};
export const billing_expense_update_payment_invoice = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.PAYMENT_INVOICE}/${id}`, data);
};